import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  AGENT_FIND_URI,
  AGENT_CREATE_URI,
  AGENT_DELETE_URI,
  AGENT_FETCH_URI,
  AGENT_PATCH_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
export default {
  getConnection() {
    return store.getters['auth/connection']
  },
  getAgents() {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const accountId = connectionService.getAccountId()
      const security = connectionService.createkwArgs()
      // eslint-disable-next-line prettier/prettier
      const args = [{ 'account_id': accountId }]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(AGENT_FIND_URI, args, kwArgs, {})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject('error')
          })
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCombinations(val) {
    let arr = []
    switch (val) {
      case 'mrn:agent_condition:speed_limit':
        arr = ['mrn:agent_condition:geofence_in']
        break
      case 'mrn:agent_condition:geofence_in':
        arr = ['mrn:agent_condition:speed_limit']
        break
      case 'mrn:agent_condition:geofence_out':
        arr = []
        break
    }
    return arr
  },
  createAgent(agentData) {
    const connection = this.getConnection()
    const accountId = connectionService.getAccountId()
    const security = connectionService.createkwArgs()
    // eslint-disable-next-line prettier/prettier
    const args = [{ 'account_id': accountId, ...agentData }]
    const kwArgs = {
      ...security
    }

    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session.call(AGENT_CREATE_URI, args, kwArgs, {}).then(
        function(response) {
          resolve(response)
        },
        function(error) {
          reject(error)
        }
      )
    })

    return Promise.race([p1, p2])
      .then(value => {
        return value
      })
      .catch(error => {
        return error
      })
  },
  deleteAgent(id) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [id]
      const security = connectionService.createkwArgs()
      const kwArgs = {
        ...security
      }
      connection.session
        .call(AGENT_DELETE_URI, args, kwArgs, {})
        .then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
        .catch(err => {
          console.log(err)
        })
    })
  },
  getAgent(id) {
    return new Promise((resolve, reject) => {
      const connection = this.getConnection()
      const security = connectionService.createkwArgs()
      // eslint-disable-next-line prettier/prettier
      const args = [id]
      const kwArgs = {
        ...security
      }
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session
          .call(AGENT_FETCH_URI, args, kwArgs, {})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            console.log('error', error)
            reject('error')
          })
      })

      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateAgent(agentId, agentData) {
    const connection = this.getConnection()
    const security = connectionService.createkwArgs()
    // eslint-disable-next-line prettier/prettier
    const args = [agentId, agentData]
    const kwArgs = {
      ...security
    }

    const p1 = new Promise((resolve, reject) => {
      setTimeout(reject, RACE_TIMEOUT, [])
    })
    const p2 = new Promise((resolve, reject) => {
      connection.session
        .call(AGENT_PATCH_URI, args, kwArgs, {})
        .then(response => {
          // console.log('p2 resposne', response)
          resolve(response)
        })
        .catch(error => {
          // console.log('p2, error', error)
          reject(error)
        })
    })

    return Promise.race([p1, p2])
      .then(value => {
        // console.log('value', value)
        return value
      })
      .catch(error => {
        // console.log('ERRORR Cathc', error)
        return error
      })
  },
  //ERRORS
  getErrorMessageByCode(code = '') {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.unexpected_error':
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
      default:
        strToReturn = i18n.t('general.dialogComponent.text_error')
        break
    }
    return strToReturn
  }
}
